module.exports = __webpack_public_path__ + "static/media/Shines_logo.4c72ff42.png";